<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item">Наші послуги</li>
      </ol>
    </nav>
  </div>
</section>

<section class="block block-uslugi">
  <div class="container">
    <div class="title title-zag-block">Наші послуги</div>
    <div class="desc-block-uslugi">Повний спектр інжинірингових послуг, пов'язаних зі створенням комфортного мікроклімату в приміщеннях різного призначення:</div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/img1.jpg" alt="Розробка проектів з розділів ОВіК" class="img-fluid">
          <div class="name-block-uslugi">Розробка проектів з розділів ОВіК</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/razrabotka-proektov-ovik'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/img2.jpg" alt="Аналіз та оптимізація проектів за розділами ОВіК" class="img-fluid">
          <div class="name-block-uslugi">Аналіз та оптимізація проектів за розділами ОВіК</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/analiz-i-optimizacziya-proektov-ovik'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/img3.jpg" alt="Реалізація об'єкта «під ключ»" class="img-fluid">
          <div class="name-block-uslugi">Реалізація об'єкта «під ключ»</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/realizatsiya-pod-klyuch'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/img4.jpg" alt="Монтажні, пуско-налагоджувальні та сервісні роботи" class="img-fluid">
          <div class="name-block-uslugi">Монтажні, пуско-налагоджувальні та сервісні роботи</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/montazhnyye-pusko-naladochnyye-servisnyye-raboty'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/sovremennoye-oborudovaniye.jpg" alt="Комплектація та постачання сучасного обладнання" class="img-fluid">
          <div class="name-block-uslugi">Комплектація та постачання сучасного обладнання</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/komplektacziya-i-postavka-oborudovaniya'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/garantijnoe-obsluzhivanie.jpg" alt="Гарантійне обслуговування" class="img-fluid">
          <div class="name-block-uslugi">Гарантійне<br>обслуговування</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/garantijnoe-obsluzhivanie'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/post-garantijnoe-obsluzhivanie.jpg" alt="Післягарантійне обслуговування" class="img-fluid">
          <div class="name-block-uslugi">Післягарантійне обслуговування</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/poslegarantijnoe-obsluzhivanie'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="li-block-uslugi">
          <img src="../../../assets/images/hard-projects.jpg" alt="Реалізація проектів за різними рівнями вимог" class="img-fluid">
          <div class="name-block-uslugi">Реалізація проектів за різними рівнями вимог</div>
          <div class="mt-auto text-center">
            <a [routerLink]="'/realizacziya-proektov-po-razlichnyim-urovnem-trebovanij'" class="my-btn">ДЕТАЛЬНЕЕ</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-additional-services></app-additional-services>
<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
